import { AdminWithdrawStatusType } from '@golden/gdk-base';
import { WithdrawDetailType } from '../enums/WithdrawDetailType';
export const withdrawDetailStatusMapAdminWithdrawStatus = {
    [WithdrawDetailType.IN_PROGRESS]: AdminWithdrawStatusType.IN_PROGRESS,
    [WithdrawDetailType.SUCCESSFUL]: AdminWithdrawStatusType.SUCCESSFUL,
    [WithdrawDetailType.THIRD_PARTY_REQUEST_FAIL]: AdminWithdrawStatusType.THIRD_PARTY_WITHDRAW_FAIL,
    [WithdrawDetailType.FAIL]: AdminWithdrawStatusType.THIRD_PARTY_WITHDRAW_FAIL
};
//# sourceMappingURL=withdrawDetailStatusMapAdminWithdrawStatus.js.map